<div *ngIf="loading" [@fadeInOut]
     style="position: absolute; background: rgba(255, 255, 255, 1); top: 0; left: 0; height: 100%; width: 100%; z-index: 50; text-align: center;">
  <sb-icon class="spinner" icon="loadingBlockAnimation" [animationOptions]="{autoplay: true, loop:true}"
           [style.color]="'#004F90'"></sb-icon>
</div>
<div class="row" style="min-height: 220px;">
  <div class="col">
    <div class="row">
      <div class="col">
        <div class="inline-block deviceOptionsHeader">
          <sb-icon class="red" icon="attention"></sb-icon>&nbsp;
        </div>
        <div class="red inline-block deviceOptionsHeader">
          &nbsp;{{'lang.devices.deleteDevice' | translate}}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tablewrap">
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100">{{'lang.globals.deviceId' | translate}}</p>
              <p class="w-100 tr mr-2"><b>{{device.id}}</b></p>
            </div>
          </div>
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100"><b>{{'lang.device.pairing.iUnderstandIrreversible' | translate}}</b></p>
              <p class="w-100 tr">
                <sb-toggle-switch onText="{{ 'lang.globals.yes' | translate }}"
                                  offText="{{ 'lang.globals.no' | translate }}" [(model)]="accept"></sb-toggle-switch>
              </p>
            </div>
          </div>
          <div class="d-flex flex-row bb">
            <div
              class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
              <p class="w-100 tc">
                <button class="btn btn-danger" [disabled]="!isSubmitValid()" (click)="deleteDevice()">
                  <sb-icon icon="trash"></sb-icon>&nbsp;{{'lang.devices.deleteDevice' | translate}}
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
